import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

/**
 * DS-1202 experimental Banner recipe: semantic tones consume the reworked
 * `semantic-{property}-{tone}` tier (incl. the dedicated text role). Neutral/tier
 * sub-variants are unchanged copies. Behind
 * `release-experimental-design-system-forms`.
 */
export const subVariantClassesExperimental = {
  default: cn('border-border bg-surface text-text-primary'),
  subtle: cn('border-border bg-surface-accent text-text-primary'),
  success: cn(
    'border-semantic-border-success bg-semantic-background-success text-semantic-text-success'
  ),
  warning: cn(
    'border-semantic-border-warning bg-semantic-background-warning text-semantic-text-warning'
  ),
  error: cn(
    'border-semantic-border-destructive bg-semantic-background-destructive text-semantic-text-destructive'
  ),
  pro: cn('border-tier-pro-border bg-tier-pro-muted text-tier-pro-text'),
  practice: cn(
    'border-tier-practice-border bg-tier-practice-muted text-tier-practice-text'
  ),
} as const;

export const bannerVariantsExperimental = cva(
  'relative flex w-full items-center gap-x-4 rounded-lg border p-4',
  {
    variants: {
      subVariant: subVariantClassesExperimental,
    },
    defaultVariants: {
      subVariant: 'default',
    },
  }
);
